import React from 'react'
import { AudioVisualizer, Video } from '../../3d'
import { Whatsapp } from '../../components'
import JobTypes from '../../helpers/JobTypesEnum'

const MediaContent = ({ artist, job, page }) => {
  const type = page.type || job.type

  switch (type) {
    case JobTypes.AUDIO: return <AudioVisualizer src={page.src} artist={artist} />
    case JobTypes.VIDEO: return <Video src={page.src} artist={artist} sizes={page.sizes} />
    case JobTypes.WHATSAPP: return <Whatsapp />
    default: return null
  }
}

export default MediaContent
